import notHandledHere from '../notHandledHere';
import { database } from 'lib_ui-services';

import setStatusOnPatchCollection from './setStatusOnPatchCollection';
const _p = {
    setStatusOnPatchCollection
};
export const _private = _p;

export default {
    verb: 'doingRollback',
    excludedNamespaceRelations: notHandledHere,
    type: 'create',
    description: 'perform actual rollback of creation',
    //this is the actual logic:
    logic: doingRollback
};

/**
 *
 * @typedef {{_id:string, [s:string]:any}} BackboneRecord
 * @typedef {{ newRecord: BackboneRecord, patch:Array<object>, path:string, httpHeaders:object}} reduxOfflineCreateResponse
 *
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: reduxOfflineCreateResponse;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 */
async function doingRollback({ data, context }) {
    await removeTheDocument(data, context);
    await _p.setStatusOnPatchCollection(context, 'clientSendFailure');
}

async function removeTheDocument(data, context) {
    const { _id } = data.newRecord;
    const db = database.get();
    const lastModified = new Date();
    //perform the actual rollback
    await db.updateMany(
        {
            criteria: { _id },
            operations: {
                $set: {
                    'meta.deleted': true,
                    'meta.deletedBy': { title: 'rollback' },
                    'meta.deletedTime': lastModified,
                    'meta.status': 'clientSendFailure',
                    'meta.modifiedTime': lastModified
                }
            }
        },
        context
    );
}
